import React from 'react';
import { Provider } from 'react-redux';

import { getStore } from '@app/redux';
import { isServer } from '@app/utils';
import { ProviderProps } from '@app/shell/types';

const ReduxProvider = ({ children, req }: ProviderProps) => {
  /**
   * @TODO - the type that the Redux store returns is incompatible with
   * the type the React Redux provider expects - possible that its
   * behind major versions?
   *
   * Store<State> vs. Store<State, Actions>
   */
  const store: any = getStore({ req });
  const key = isServer ? 'ssr-app' : 'client-app';

  return (
    <Provider key={key} store={store}>
      {children}
    </Provider>
  );
};

export default ReduxProvider;
